export interface CompanySettingsValues { // CompanySettingsData from CompanySettingsController.cs
    CompanyID: number;
    FieldID: number;
    FieldType: CompanySettingsType;
    FieldGroup: string;
    FieldName: string;
    DisplayName: string;
    NumericValue: number;
    TextValue: string;
    Options: CompanySettingsOptions[];
}

export interface CompanySettingsOptions { // CompanyFieldOptionDTO.cs
    DisplayValue: string;
    NumericValue: number;
    TextValue: string;
}

export enum CompanySettingsType { // FieldType from AdminEnums.cs
    Number = 0,
    Text = 1,
    Boolean = 2,
    Select = 3,
    File = 4
}

export interface FieldGroup { //FieldGroup object to hold internal english value and Localized Display value
    GroupName: string;
    DisplayName: string;
}

export interface SSOSettingsValues { //values to hold sso settings values
    EnableSSO: boolean;
    SSOClientID: string;
    SSOClientSecret: string;
    SSOIdentityProviderURL: string;
    SSOProvider: string;
}

export const DEFAULT_COMPANY_TOOLTIP_TEXT = {
    Priority_For_User_Identifier_T: 'Preferred field used to identify users in login based selectors',
    CultureName_T: 'Affects how certain data is displayed, such as numbers',
    WeekStartDay_T: 'Defines the day the week starts on',
    CoinToCurrencyValue_T: 'Sets the value of each coin in your currency',
    QualityDisputes_T: 'Allow agent to  accept or dispute quality sores',
    LogoImage_T: 'Logo displayed on the site',
    LoginSplashImage_T: 'Splash logo displayed on the login page',
    LoginLogo_T: 'Logo displayed on the login page',
    UseActiveForData_T: 'Only display data for active members',
    IsBPO_T: 'Business process outsourcing allows data to be displayed based on strict group level hierarchies.',
    CoachingAcknowledge_T: 'Send agents a notification to acknowledge coaching session is correct.',
    UseActiveForDisplay_T: 'Only display active members',
    ShowNoneGroup_T: 'Show None group in dashboard group selector.'
};
